import { useEffect, useState } from "react";
import { SITE, whatsappLink } from "@/config/site";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { href: "#sobre", label: "Sobre" },
  { href: "#servicos", label: "Perícia" },
  { href: "#tratamentos", label: "Tratamentos" },
  { href: "#galeria", label: "Galeria" },
  { href: "#faq", label: "FAQ" },
  { href: "#contato", label: "Contato" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/85 backdrop-blur-xl border-b border-[#D4AF37]/20"
          : "bg-transparent"
      }`}
    >
      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center h-40 lg:h-20">
        <a
          href="#top"
          data-testid="header-logo-link"
          className="absolute left-1/2 -translate-x-1/2 lg:static lg:translate-x-0 flex items-center gap-3 group"
        >
          <img
            src={SITE.logoUrl}
            alt={SITE.name}
            className="h-40 w-40 lg:h-14 lg:w-14 object-contain"
          />
          <div className="hidden lg:flex flex-col leading-tight">
            <span className="font-serif-display text-lg text-white tracking-wide">
              {SITE.shortName}
            </span>
            <span className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37]/80">
              Perito Judicial
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-10 mx-auto">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.replace("#", "")}`}
              className="text-sm tracking-wide text-white/75 hover:text-[#D4AF37] transition-colors duration-300 relative group"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#D4AF37] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-whatsapp"
            className="hidden md:inline-block bg-[#D4AF37] text-[#050505] font-medium text-sm tracking-wide px-6 py-3 hover:bg-[#F0C950] transition-colors duration-300"
          >
            Solicitar Perícia
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Abrir menu"
            className="lg:hidden text-[#D4AF37] p-2"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#050505]/95 backdrop-blur-xl border-t border-[#D4AF37]/20"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${link.href.replace("#", "")}`}
                className="text-base text-white/85 hover:text-[#D4AF37] transition-colors tracking-wide border-b border-white/5 pb-3"
              >
                {link.label}
              </a>
            ))}
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-cta-whatsapp"
              className="bg-[#D4AF37] text-[#050505] font-medium px-6 py-3 text-center mt-2"
            >
              Solicitar Perícia
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
